import { immerable } from "immer";

export class BaseTransformerImpl {
  [immerable]: true;
  constructor() {
    this[immerable] = true;
  }
}
